// extracted by mini-css-extract-plugin
module.exports = {"icon":"LocalAuthConfigContainer-icon-4f1ce843c7c7ca0c7fc6ef0b1644e585"};